/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonSave.vue?vue&type=template&id=5b74c1b3"
import script from "./ButtonSave.ts?vue&type=script&lang=ts&external"
export * from "./ButtonSave.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports